import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  BIZFLEX_BUSINESS_REGISTRATION_URL,
  BIZFLEX_LOGIN_URL,
  BIZFLEX_REGISTER_FROM_REWARDS_URL,
  BIZFLEX_REGISTER_URL,
} from '../components/common/constants';
import {
  attributedSignupUrl,
  captureAttribution,
} from './marketingAttribution';

/**
 * Returns an attributed outbound URL that updates when the page query string changes.
 */
export function useAttributedUrl(rawUrl, marketingAllowed = true) {
  const { search } = useLocation();
  const [url, setUrl] = useState(rawUrl);

  useEffect(() => {
    captureAttribution(marketingAllowed);
    setUrl(attributedSignupUrl(rawUrl, marketingAllowed));
  }, [rawUrl, marketingAllowed, search]);

  return url;
}

/** Common BizFlex app outbound URLs with marketing attribution applied. */
export function useBizflexAppUrls(marketingAllowed = true) {
  const registerUrl = useAttributedUrl(BIZFLEX_REGISTER_URL, marketingAllowed);
  const registerFromRewardsUrl = useAttributedUrl(
    BIZFLEX_REGISTER_FROM_REWARDS_URL,
    marketingAllowed,
  );
  const loginUrl = useAttributedUrl(BIZFLEX_LOGIN_URL, marketingAllowed);
  const businessRegistrationUrl = useAttributedUrl(
    BIZFLEX_BUSINESS_REGISTRATION_URL,
    marketingAllowed,
  );

  return {
    registerUrl,
    registerFromRewardsUrl,
    loginUrl,
    businessRegistrationUrl,
  };
}
